import {create} from 'zustand';
import { activeStatus, deleteTag, manageTags, postTag, tagContent} from '../api_layer/api';
import { tagOrder } from '../api_layer/api';

export const useTagsStore = create((set) => ({
    tagData: [],
    orderData:[],
    tagLoading: false,
    orderLoading:false,
    removeLoading:false,
    error: null,
    fetchTagData: async (page) => {
      try {
        set({ tagLoading: true, error: null });
        const response = await manageTags(page);
        set({ tagData: response.data, tagLoading: false });
      } catch (error) {
        set({ error: error.message, tagLoading: false });
      }
    },
    fetchTagOrder: async () => {
      try {
        set({ orderLoading: true, error: null });
        const response = await tagOrder();
        set({ orderData: response.data, orderLoading: false });
      } catch (error) {
        set({ error: error.message, orderLoading: false });
      }
    },
    fetchTagComponent: async (id) => {
      try {
        set({ tagComponentLoading: true, error: null });
        const response = await tagContent(id);
        set({ tagComponentData: response.data, tagComponentLoading: false });
      } catch (error) {
        set({ error: error.message, tagComponentLoading: false });
      }
    },
    AddTag: async (payload, setToaster, fetchTagData, setModalShow) => {
      try {
        set({ statusLoading: true, error: null });
        const response = await postTag(payload);
        setToaster("Tag Creation", "Tag created successfully", "success");
        fetchTagData(0);
        setModalShow(false);
        set({ statusLoading: false });
      } catch (error) {
        setToaster("Tag Creation", error.response?.data?.message, "danger");
        set({ error: error.message, statusLoading: false });
      }
    },
    updateActiveStatus: async (id, status, setToaster, fetchTagData) => {
      try {
        set({ activeLoading: true, error: null });
        const response = await activeStatus(id, status);
        set({ activeData: response.data, activeLoading: false });
        setToaster("Status", "Status changed successfully", "success");
        fetchTagData(0);
      } catch (error) {
        setToaster("Status", "Status not updated", "danger");
        set({ error: error.message, activeLoading: false });
      }
    },
    removeTag: async (id, setToaster, fetchTagData) => {
      try {
        set({ removeLoading: true, error: null });
        const response = await deleteTag(id);
        setToaster("Tag Remove", "Tag removed successfully", "success");
        fetchTagData(0);
        set({ removeLoading: false });
      } catch (error) {
        setToaster("Tag Remove", error.response?.data?.message, "danger");
        set({ error: error.message, removeLoading: false });
      }
    },
  }));